<!-- 组件说明 -->
<template>
  <div :class="['swipe_wrapper',data.prop.btnShape,data.prop.btnPosition]">
    <mt-swipe :auto="4000" :style="'height:'+swipeHeight+'px;'" >
      <mt-swipe-item v-for="(item, index) in data.data" :key="index" :style="'height:'+swipeHeight+'px;'" >
          <img class="item" :src="item.url" @click="goDetail(item.action)"/>
      </mt-swipe-item>
    </mt-swipe>
  </div>
</template>

<script>
//import x from ''
import $ from 'jquery';
export default {
  props: ['data'],
  components: {},
  data() {
    return {
      swipeHeight:'100'
    };
  },
  computed: {},
  mounted() {
    let div = this.$el;
    const indicators = div.getElementsByClassName('mint-swipe-indicators');
    // $(indicators).css('background', 'red');
    const indicator = this.$el.getElementsByClassName('mint-swipe-indicator');
    // console.log('===indicator==', indicator);
    // console.log('===indicator==', indicators);
    // console.log('===indicator==', $(indicators).css('background'));
    if(this.data.data.length>0){
      this.data.data.forEach((item,index)=>{
        this.getImgInfo(item.url)
      })
    }
    
    
  },
  methods: {
    goDetail(action){
      location=action
      
    },
    getImgInfo(url){
      let img = new Image()
      var imgHeight
      img.src  = url;
      img.onload = ()=>{
        let clientWidth  = document.documentElement.clientWidth>520 ? 520:document.documentElement.clientWidth
        imgHeight = (clientWidth/img.width)*img.height
        this.swipeHeight = imgHeight>this.swipeHeight?imgHeight:this.swipeHeight
      }

    },
  },
  created() {
    //生命周期 - 创建完成
  },
  destroyed() {
    //生命周期 - 销毁完成
  },
};
</script>

<style lang='scss' scoped>
.swipe_wrapper {
  // max-height: 8rem;
  // height: auto;
  .square {
    .mint-swipe-indicators {
      .mint-swipe-indicator {
        border-radius: 0;
        background: red;
      }
    }
  }
  .item {
    width: 100%;
    // height: 100%;
  }
  // .mint-swipe{
  //   max-height: 8rem;
  //   .mint-swipe-item{
  //     max-height: 8rem;
  //   }
  // }
}
</style>
<style lang='scss' >
.left {
  .mint-swipe-indicators {
    left: 0.2rem;
    transform: translateX(0);
    bottom: 0.2rem;
  }
}
.right {
  .mint-swipe-indicators {
    left: inherit;
    right: 0.2rem;
    transform: translateX(0);
    bottom: 0.2rem;
  }
}
.square {
  .mint-swipe-indicators {
    .mint-swipe-indicator {
      border-radius: 0;
    }
    .mint-swipe-indicator.is-active {
      opacity: 0.8;
    }
  }
}
.rectangle {
  .mint-swipe-indicators {
    .mint-swipe-indicator {
      height: 0.4rem;
      width: 0.64rem;
      border-radius: 0;
    }
    .mint-swipe-indicator.is-active {
      opacity: 0.8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/Slider.vue